// Lecture de la fraîcheur d'une métrique d'entropie.
// Voir docs/SPEC_PEREMPTION_METRIQUES.md.
//
// ⚠️ Ces seuils sont des seuils de LECTURE. Aucune valeur n'est modifiée,
// aucun total n'est recalculé : seul le rendu change. Un module figé reste
// lisible — simplement, on voit qu'il est figé.
//
// `age_seconds === null` signifie JAMAIS mesuré depuis le démarrage du
// backend. C'est un état distinct d'un âge élevé : « aucune donnée » n'est pas
// « donnée ancienne », et l'interface ne doit pas les confondre.

export function freshness(ageSeconds) {
  if (ageSeconds === null || ageSeconds === undefined) {
    return {
      opacity: 0.35,
      title: "Jamais mesuré depuis le démarrage du backend",
      suffix: "—",
    };
  }
  if (ageSeconds < 10) {
    return {
      opacity: 1,
      title: `Mesuré il y a ${ageSeconds.toFixed(1)} s`,
      suffix: "",
    };
  }
  if (ageSeconds < 300) {
    return {
      opacity: 0.55,
      title: `Valeur figée — dernière mesure il y a ${Math.round(ageSeconds)} s`,
      suffix: `${Math.round(ageSeconds)}s`,
    };
  }
  return {
    opacity: 0.35,
    title: `Valeur périmée — aucune mesure depuis ${Math.round(ageSeconds / 60)} min`,
    suffix: `${Math.round(ageSeconds / 60)}min`,
  };
}
